import c from '../common';

export default{
    "customer":"Contact Person",
    "customerTel":"Contact Person Telephone",
    "VNumber":"Voucher Number",
    "AppliedTime":"Booking Applied On:",
    "ValidTime":"Booking Valid between:",
    "deliveryAddress":"Delivery Address",
    "deliveryDate":"Delivery Date",
    "NoName":"Name Not Avaliable",
    "ordered":"Ordered",
    "orderDetail":"Booking Detail",
    "qty":" Qty",
    "orderContent":"Order Content",
    "NA":"No Data",
    "orderType":"Order Type",
};